import React from "react";

type ErrorBoundaryProps = {
  children: React.ReactNode;
  section?: string;
  fallback?: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, info: any) {
    console.error(`[ErrorBoundary] ${this.props.section || 'Section'} error:`, error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <section className="py-12">
          <div className="container mx-auto px-4 text-center">
            <div className="inline-block rounded-lg border border-gold/30 bg-card px-4 py-3 text-foreground/80">
              Er ging iets mis in deze sectie. We hebben een veilige weergave getoond.
            </div>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
